import React from "react";
import { Provider as JotaiProvider } from "jotai";
import { Container } from "components/Container";
import {
  FiltroDescansoMedico,
  TablaHistoricoDescansoMedico,
  DrawerCargarHistoricoDescansoMedico,
  ModalDetalleDescansoMedico,
} from "./componentes";

const DescansoMedicoPage = () => {
  return (
    <JotaiProvider>
      <Container titulo="Descanso Médico">
        <FiltroDescansoMedico />
        <TablaHistoricoDescansoMedico />
        <DrawerCargarHistoricoDescansoMedico />
        <ModalDetalleDescansoMedico />
      </Container>
    </JotaiProvider>
  );
};

export default DescansoMedicoPage;
